<ng-container *ngIf="router.url.indexOf('resume-preview') == -1">
    <footer [ngClass]="(router.url.indexOf('/jobs') > -1) ||(router.url.indexOf('/employer') > -1) ? '':'homefooter'">
        <div class="container">

            <!-- userService.getCurrentUser().is_profile_complete -->

            <div class="container" *ngIf="!userService.getCurrentUser().is_profile_complete">
                <ng-container *ngIf="JoinData != undefined && (JoinData | json) != '{}'">
                    <div class="get-started" *ngIf="userService.getCurrentUser() != undefined  && (userService.getCurrentUser() | json) != ({} | json) && userService.getCurrentUser().jobseeker">
                        <div class="heading" [innerHtml]="JoinData.join_us.description">
                        </div>

                        <ng-container *ngIf="userService.getCurrentUser() == undefined || (userService.getCurrentUser() | json) == ({} | json) || userService.getCurrentUser() == ''">
                            <a (click)="allPopup.openLoginForm('jobseeker')" href="javascript:void(0)"><button type="button" class="btn btn-primary"> {{'SHARED.FOOTER.POST_A_JOB' | translate}} </button></a>
                        </ng-container>

                        <!-- <ng-container *ngIf="userService.getCurrentUser() != undefined  && (userService.getCurrentUser() | json) != ({} | json) && userService.getCurrentUser() != ''">
                        <a href="javascript:void(0)" (click)="checkProfileCompelete()"><button type="button" class="btn btn-primary" >{{'HOME.UPLOAD_RESUME' | translate}}</button></a>
                    </ng-container> -->
                    </div>

                    <div *ngIf="userService?.getCurrentUser()?.is_plan_expired">
                        <div class="get-started" *ngIf="userService.getCurrentUser() == undefined || (userService.getCurrentUser() | json) == ({} | json) || userService.getCurrentUser() == '' || !userService.getCurrentUser().jobseeker">
                            <div class="heading" [innerHtml]="JoinData.footer_text.description">
                            </div>

                            <div *ngIf="!userService?.getCurrentUser()?.is_plan_expired">
                                <ng-container *ngIf="userService.getCurrentUser() == undefined || (userService.getCurrentUser() | json) == ({} | json) || userService.getCurrentUser() == ''">
                                    <a (click)="allPopup.openLoginForm('jobseeker')" href="javascript:void(0)"><button type="button" class="btn btn-primary"> {{'SHARED.FOOTER.JOIN_NOW' | translate}} </button></a>
                                </ng-container>

                                <ng-container *ngIf="userService.getCurrentUser() != undefined  && (userService.getCurrentUser() | json) != ({} | json) && userService.getCurrentUser() != ''">
                                    <a routerLink="/employer/post_job"><button type="button" class="btn btn-primary"> {{'SHARED.FOOTER.JOIN_NOW' | translate}} </button></a>
                                </ng-container>

                            </div>
                            <div *ngIf="userService?.getCurrentUser()?.is_plan_expired">
                                <ng-container *ngIf="userService.getCurrentUser() != undefined  && (userService.getCurrentUser() | json) != ({} | json) && userService.getCurrentUser() != ''">
                                    <div class="alert alert-danger mt-2" role="alert">
                                        No Payment Avaliable ! </div>
                                </ng-container>
                            </div>

                        </div>
                    </div>

                </ng-container>
            </div>
            <div class="topfooter">
                <div class="footerinfo">
                    <figure>
                        <a routerLink="/"><img src="{{env.SITE_IMAGE_URL}}logo.png" alt="logo" width="100%" height="100%"></a>
                    </figure>
                    <ng-container *ngIf="footerData!= undefined && (footerData | json) != '{}'">
                        <ul>
                            <li><i class="fa fa-phone" aria-hidden="true"></i><strong>{{'SHARED.FOOTER.PHONE' | translate}}</strong> <span><a href="tel:{{footerData['ContactUs.phone_number']}}" >{{footerData['ContactUs.phone_number']}}</a></span></li>
                            <!-- <li><i class="fa fa-envelope" aria-hidden="true"></i><strong>{{'SHARED.FOOTER.EMAIL' | translate}}</strong> <span><a href="mailto:{{footerData['ContactUs.email']}}">{{footerData['ContactUs.email']}}</a></span></li> -->
                        </ul>
                    </ng-container>
                </div>
                <div class="footerlink joblink">
                    <!-- <h4>{{'SHARED.FOOTER.JOB_CATEGORIES' | translate}}</h4>
					<ng-container *ngIf="featuredCategory.length">
						<a class="mobileshow" data-toggle="collapse" href="#footerlinkcollapse1" role="button" aria-expanded="false" aria-controls="footerlinkcollapse1">{{'SHARED.FOOTER.JOB_CATEGORIES' | translate}}</a>
						<div class="collapse" id="footerlinkcollapse1">
							<ul>
								<ng-container *ngFor="let featuredCategory of featuredCategory">
									<li><a routerLink="/jobs/{{featuredCategory.slug}}">{{featuredCategory.name}}</a></li>
								</ng-container>
							</ul>
						</div>
					</ng-container> -->
                </div>
                <div class="footerlink expedilink">
                    <h4>{{'GLOBAL.SITE_NAME_FOOTER' | translate}}</h4>
                    <a class="mobileshow" data-toggle="collapse" href="#footerlinkcollapse2" role="button" aria-expanded="false" aria-controls="footerlinkcollapse2">{{'GLOBAL.SITE_NAME_FOOTER' | translate}}</a>
                    <div class="collapse" id="footerlinkcollapse2">
                        <ul>
                            <li><a routerLink="/about-us">{{'GLOBAL.ABOUT_US' | translate}}</a></li>
                            <li><a routerLink="/contact-us">{{'GLOBAL.CONTACT_US' | translate}}</a></li>

                            <li><a routerLink="/jobs">{{'GLOBAL.JOBS' | translate}}</a></li>
                            <li><a routerLink="/privacy-policy">{{'GLOBAL.PRIVACY_POLICY' | translate}}</a></li>

                            <li><a routerLink="/faq">{{'GLOBAL.FAQ' | translate}}</a></li>
                            <li><a routerLink="/terms-condition">{{'GLOBAL.TERMS_OF_USE' | translate}}</a></li>


                            <!-- <li><a routerLink="/employer/paymentpolicy">{{'GLOBAL.PTCP' | translate}}</a></li>
                            <li><a routerLink="/employers">{{'GLOBAL.EMPLOYERS' | translate}}</a></li>
                            <li><a routerLink="/trust-and-safety">{{'GLOBAL.TRUST_AND_SAFETY' | translate}}</a></li> -->

                            <li><a routerLink="/blogs">{{'GLOBAL.BLOG' | translate}}</a></li>
                            <li><a routerLink="/fraud-alert">{{'GLOBAL.FRAUD_ALERT' | translate}}</a></li>

                            <!-- <li><a routerLink="/resumes">{{'RESUME.RESUME_TEMPLATES' | translate}}</a></li> -->
                        </ul>
                    </div>
                </div>
                <!-- <div class="footerbtn">
                    <ng-container>
                        <div class="play-store">
                            <a target="_blank" href="https://play.google.com/store/apps/details?id=com.expediusa"><span><img src="{{env.SITE_IMAGE_URL}}google-play.png"></span></a>
                            <a target="_blank" href="https://apps.apple.com/us/app/expediusa/id1628317817"><span><img src="{{env.SITE_IMAGE_URL}}app-play.png"></span></a>
                        </div>
                    </ng-container>
                </div> -->
            </div>
            <ng-container *ngIf="footerData != null && footerData!= undefined && (footerData | json) != '{}'">
                <div class="copyright">
                    <ul>
                        <li><a href="{{footerData['Social.facebook']}}" target="_blank"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
                        <li><a href="{{footerData['Social.twitter']}}" target="_blank"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
                        <li><a href="{{footerData['Social.instagram']}}" target="_blank"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
                        <li><a href="{{footerData['Social.linkdin']}}" target="_blank"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>

                    </ul>
                    <p [innerHtml]="footerData['Site.copyright_text']"></p>
                </div>
            </ng-container>
        </div>
        <div class="chat_card" *ngIf="isChatCardVisible">
            <div class="chat_card_inn">
                <div class="ch_hd">
                    <div class="row">
                        <div class="col-sm-1 qu_rht align-self-center cp" *ngIf="isChatSelected">
                            <i class="fa fa-chevron-left" aria-hidden="true" (click)="back()"></i>
                        </div>
                        <div class="col-sm-1 qu_rht align-self-center" *ngIf="!isChatSelected">
                        </div>
                        <div class="col-sm-8 align-self-center mt-1">
                            <h3>Ask Anah</h3>
                        </div>
                        <div class="col-sm-3 qu_rht align-self-center cp">
                            <i class="fa fa-times-circle" aria-hidden="true" (click)="toggleChatCard()"></i>
                        </div>
                    </div>
                </div>
                <ng-container *ngIf="userService.getCurrentUser() != undefined && (userService.getCurrentUser() | json) != '{}'">
                    <div class="p-3 cont_msg" *ngIf="isChatCardVisible">
                        <div class="chat-list" *ngIf="!isChatSelected">
                            <!-- Check if chatList is empty -->
                            <div *ngIf="chatList.length === 0" class="no-chats-message">
                                <p>No chats found</p>
                            </div>
                            <!-- Display chat items if chatList is not empty -->
                            <div *ngIf="chatList.length > 0">
                                <div *ngFor="let chat of chatList" class="chat-item" (click)="loadMessageList(chat.session_id)">
                                    <div class="media">
                                        <img alt="user" width="100%" height="100%" src="/assets/images/alex.png" class="img_ch_pr">
                                        <div class="media-body">
                                            <h6 class="mt-0 ellipsis_ti">{{ chat.message }}</h6>
                                            <p class="msg_dte">{{ chat.created | date : 'MMM d yyyy ' }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>







                        <div *ngIf="isLoadingMessages" class="loading-spinner">
                            Loading...
                        </div>
                        <div *ngIf="!isLoadingMessages">
                            <div *ngIf="messages.length === 0 && isChatSelected">
                                No messages found. Starting a new conversation...
                            </div>
                        </div>
                        <div *ngFor="let message of messages">
                            <div [ngClass]="{'left_chat': message.type === 'outgoing', 'right_chat': message.type === 'incoming'}">
                                <div class="media">
                                    <!-- Conditionally show user image for incoming messages -->
                                    <img *ngIf="message.type === 'outgoing'" alt="logo" src="/assets/images/alex.png" class="ch_pr">
                                    <div class="media-body">
                                        <p>{{ message.text }}</p>
                                    </div>
                                    <!-- Conditionally show user image for outgoing messages -->
                                    <img *ngIf="message.type === 'incoming'" alt="logo" src="/assets/images/user.png" class="ch_pr1">
                                </div>
                            </div>
                        </div>
                        <div>

                        </div>

                        <!-- <div *ngIf="!isLoadingMessages">
                            <div class="p-3" *ngIf="isChatSelected">
                                <div *ngFor="let message of messages" [ngClass]="{ 
                                'message-answer': !message.userid || message.userid === '', 
                                'message-question': message.userid && message.userid !== '' 
                            }" class="message-container">
                                    <img alt="logo" width="100%" height="100%" src="/assets/images/user.png" class="img_ch_pr"> {{ message.text }}
                                </div>
                            </div>
                        </div> -->





                        <div class="msg_sec" *ngIf="isChatCardVisible">
                            <div class="row">
                                <div class="col-sm-10 align-self-center pr-0">
                                    <div>
                                        <input type="text" class="form-control" [(ngModel)]="currentMessage" placeholder="type here..." />
                                    </div>
                                </div>
                                <div class="col-sm-2 align-self-center">
                                    <button (click)="sendMessage()"><i class="fa fa-paper-plane" aria-hidden="true"></i></button>
                                </div>
                            </div>
                        </div>

                        <!-- Display "Start Conversation" button when no chat is selected -->
                        <div *ngIf="!isChatSelected" class="msg_sec">
                            <div class="row">
                                <div class="col-sm-12 text-center">
                                    <button class="btn_conv" (click)="startConversation()">Start Conversation</button>
                                </div>
                            </div>
                        </div>

                    </div>

                    <!-- Display the chat card toggle button if needed -->
                    <!-- <button (click)="toggleChatCard()">Chat</button> -->
                </ng-container>




                <!-- Show Login and Signup buttons if not logged in -->
                <ng-container class="mcspace" *ngIf="userService.getCurrentUser() == undefined || (userService.getCurrentUser() | json) == '{}'">

                    <div class="mcspace">
                        <div class="align-self-center w-100 text-center">
                            <div class="bbh">
                                <p>

                                    {{'GLOBAL.LOGIN_SIGNUP' | translate}}
                                </p>
                            </div>
                            <button type="button" class="btn btn-primary" (click)="allPopup.openLoginForm('jobseeker');toggleChatCard()">Login</button>
                            <button type="button" class="btn btn-primary btspace" (click)="allPopup.openSignupForm('jobseeker');toggleChatCard()">Signup</button>
                        </div>
                    </div>

                </ng-container>

            </div>
        </div>
        <div class="chat_butn">

            <button #chatToggle (click)="toggleChatCard()"><i class="fa fa-comments" aria-hidden="true"></i>
            </button>



        </div>
    </footer>
    <app-popup #allPopup></app-popup>
</ng-container>